const FETCH_EXPENSES = 'fetch_expenses';
const FETCH_EXPENSES_CSV = 'fetch_expenses_csv';
const FETCH_EXPENSE = 'fetch_expense';
const DELETE_EXPENSE = 'delete_expense';
const PERSIST_EXPENSE = 'persist_expense';
export default {
    FETCH_EXPENSES,
    FETCH_EXPENSES_CSV,
    FETCH_EXPENSE,
    DELETE_EXPENSE,
    PERSIST_EXPENSE,
};
